const baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'http://127.0.0.1:5001';
// const url = `${baseUrl}/v4/bot-forge/assets/upload`;
const url = `/api/v1/bot-forge/assets/upload`;

const download = (filename, textToDownload) => {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textToDownload));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

const updateSpecificValue = (value, parentArray, editableBotData, check) => {
    let tempObj, newEditableData = {
        ...editableBotData
    };
    if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
        tempObj = newEditableData;
    } else {
        tempObj = newEditableData.UI_OPTIONS;
    }
    for (let i = 0; i <= parentArray.length; i++) {
        // console.log(i, check, parentArray, tempObj);
        if (i === parentArray.length) {
            tempObj.VALUE = value;
        } else {
            if ((i === (parentArray.length - 1)) && (check === 'radioType' || check === 'arrAttachment' || check === 'attachment')) {
                tempObj[parentArray[i]] = value;
                i++;
            } else {
                tempObj = tempObj[parentArray[i]];
            }
        }
    }
    // console.log('Updated Data', newEditableData);
    return newEditableData;
};

const upload = (files, replaceFlag, successFun, errorFun ) => {
    let headers = {};
    let formData = new FormData();
    const botId = window.localStorage.getItem('bot_id');
    const token = localStorage.getItem('id_token');

    formData.append('file', files[0]);
    formData.append('botId', botId);
    if (token) {
        headers.Authorization = token;
        headers['team-id'] = localStorage.getItem('team_id');
        headers['hyb-agent-id'] = localStorage.getItem('user_id');

        if (replaceFlag) {
            headers.replace = false;
            headers.replaceName = '';
        }
    }

    fetch(url, {
        method: 'PUT',
        headers,
        body: formData
    }).then( async response => {
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;
        if (!response.ok) { // if response fail
            return Promise.reject(response);
        }
        if (successFun && data.data) {
            successFun(data.data);
        }
    }).catch((error) => {
        console.error('Error:', error);
        if(errorFun) {
            errorFun(error)
        }
    })
}

const copyToClipboard = (str, cb) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if(cb) {
        cb();
    }
};

const loadFonts = (fontArray) => {
    if(!Array.isArray(fontArray) && !fontArray.length) {
        return;
    }
    let styleElement = document.getElementById('fontStyle');
    if(styleElement) {
        styleElement.remove();
    }

    let htmlStr = '';
    for (let i = 0; i < fontArray.length; i++) {
        const element = fontArray[i];
        fetch(element.VALUE)
        .then((response) => response.text())
        .then((text) => {
            htmlStr += text;
            if(i === fontArray.length - 1) {
                let newStyle = document.createElement('style');
                newStyle.setAttribute("rel", "stylesheet");
                newStyle.setAttribute("id", "fontStyle");
                newStyle.appendChild(document.createTextNode(htmlStr));
	            document.head.appendChild(newStyle);
            }
        });
    }
}

const hideSideNavArr = ['/bot-list']

export {
    download,
    updateSpecificValue,
    upload,
    copyToClipboard,
    loadFonts,
    hideSideNavArr
}